 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_cover'
 import HTML01_HALFTITLE from '@/components/html/01_halftitle'
 import HTML02_OTHERBOOKS from '@/components/html/02_otherbooks'
 import HTML03_TITLEPAGE from '@/components/html/03_titlepage'
 import HTML04_COPYRIGHT from '@/components/html/04_copyright'
 import HTML05_CONTENTS from '@/components/html/05_contents'
 import HTML06_INTRODUCTION from '@/components/html/06_introduction'
 import HTML07_CHAP1 from '@/components/html/07_chap1'
 import HTML08_CHAP2 from '@/components/html/08_chap2'
 import HTML09_CHAP3 from '@/components/html/09_chap3'
 import HTML10_CHAP4 from '@/components/html/10_chap4'
 import HTML11_CHAP5 from '@/components/html/11_chap5'
 import HTML12_ANNOTATED_BIBLIOGRAPHY from '@/components/html/12_annotated_bibliography'
 import HTML13_ABOUT_THE_AUTHOR from '@/components/html/13_about_the_author'
 import HTML14_OTHER_RELATED_RESOURCES from '@/components/html/14_other_related_resources'
 import HTML15_ABOUT_THE_BOOK from '@/components/html/15_about_the_book'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/05_contents",
 			"name" : "html/05_contents",
 			"component" : HTML05_CONTENTS
 		},
 		{
 			"path" : "/html/06_introduction",
 			"name" : "html/06_introduction",
 			"component" : HTML06_INTRODUCTION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js